import React, { useState, useRef, useEffect } from "react"
import Icon from "../../../components/AppIcon"
import { DATE_RANGE_OPTIONS } from "../../../utils/dateRangeHelpers"

const DashboardHeader = ({ organization, dateRange, onDateRangeChange, onExport, onCustomize }) => {
  const [open, setOpen] = useState(false)
  const menuRef = useRef(null)
  const activeLabel = DATE_RANGE_OPTIONS?.find((r) => r?.key === dateRange)?.label || "30 days"

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          Good morning, {organization?.name || "there"}.
        </h1>
        <p className="text-muted-foreground mt-1">
          Here's what's happening across your learning ecosystem.
        </p>
      </div>

      <div className="flex items-center gap-2">
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setOpen((o) => !o)}
            className="flex items-center gap-2 border border-border bg-card px-3 py-2 rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
          >
            {activeLabel}
            <Icon name="ChevronDown" size={14} />
          </button>

          {open && (
            <div className="absolute right-0 mt-1 w-40 bg-card border border-border rounded-lg shadow-md z-30 py-1">
              {DATE_RANGE_OPTIONS?.map((option) => (
                <button
                  key={option?.key}
                  onClick={() => {
                    onDateRangeChange(option?.key)
                    setOpen(false)
                  }}
                  className={`w-full text-left px-3 py-2 text-sm hover:bg-muted transition-colors ${
                    option?.key === dateRange ? "text-primary font-medium" : "text-foreground"
                  }`}
                >
                  {option?.label}
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          onClick={onExport}
          className="flex items-center gap-2 border border-border bg-card px-3 py-2 rounded-lg text-sm font-medium text-foreground hover:bg-muted transition-colors"
        >
          <Icon name="Download" size={14} />
          Export Report
        </button>

        <button
          onClick={onCustomize}
          className="flex items-center gap-2 bg-primary text-primary-foreground px-3 py-2 rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
        >
          <Icon name="LayoutGrid" size={14} />
          Customize Dashboard
        </button>
      </div>
    </div>
  )
}

export default DashboardHeader